export const SET_GENERAL_ERROR = 'app/SET_GENERAL_ERROR';
export const CLEAR_GENERAL_ERROR = 'app/CLEAR_GENERAL_ERROR';
export const SHOW_NOTIFICATION = 'app/SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'app/CLEAR_NOTIFICATION';
export const SET_LOADING = 'app/SET_LOADING';
export const UNSET_LOADING = 'app/UNSET_LOADING';
